import { createSxStyles } from "@common/createSxStyles";

export const useTreatmentDialogStyles = () =>
    createSxStyles({
        content: {
            display: "flex",
            flexDirection: "column",
            gap: 1,
        },
        subHeader: {
            display: "flex",
            justifyContent: "center",
        },
        description: {
            fontSize: 13,
            lineHeight: 1.5,
            color: (theme) => theme.palette.text.secondary,
        },
        group: {
            display: "flex",
            flexDirection: "column",
        },
        sectionContent: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
        },
        scoreValue: {
            fontWeight: 600,
        },
        twoColumnRow: {
            display: "flex",
            gap: 2,
        },
        column: {
            flex: 1,
        },
        driftBanner: {
            display: "flex",
            alignItems: "center",
            gap: 1,
        },
        linkedTask: {
            display: "flex",
            justifyContent: "flex-end",
            // Pull up under the deadline row, countering the column gap so the link reads as attached to it.
            marginTop: -2,
            fontSize: 13,
        },
    });
